import { $el } from '../elements';
import { $svg, UISVG } from '../svg';
import { UIClassesSpec } from '../types';

export function hLine(classes?: UIClassesSpec) {
    const line = new UISVG;
    line.add($svg.LINE(0, '50%', '100%', '50%', 'r-stroke'));
    return $el.DIV(['ui-line', classes], line);
}